import { executeRequest, Request } from '@jfs/network'
import xml2js from 'react-native-xml2js'
import { getNetworkResponseError, isStatusOK, parseXmlToJson } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { getFirstName, getLastName } from '../authenticateOtp'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const getEncryptedAadharXml = (resp: any, poiPoaJsonData: any, uid: any) => {
  poiPoaJsonData.KycRes.UidData[0].$.uid = uid.substring(0, 8).replace(/[0-9]/g, '*') + uid.substring(8)
  console.log('uid', poiPoaJsonData.KycRes.UidData[0].$.uid)
  const builder = new xml2js.Builder()
  const poiPoaXMLData = builder.buildObject(poiPoaJsonData)
  const base64PoiPoaXMLData = btoa(poiPoaXMLData)
  resp.KuaRes.kycRes[0]._ = base64PoiPoaXMLData
  const adhaarXML = builder.buildObject(resp)
  return btoa(adhaarXML)
}

const responseParser = async (data: any) => {
  console.log(data)
  if (isStatusOK(data)) {
    const resp: any = await parseXmlToJson(data.data, { explicitCharkey: true }).catch((err: any) => {
      console.log('err', err)
      const error = getNetworkResponseError(err)
      throw error
    })
    console.log('resp', resp)
    if (resp?.KuaRes?.$?.err) {
      const error = {
        code: resp?.KuaRes?.$?.err,
        message: resp?.KuaRes?.$?.err + ' - An unexpected error has occoured',
      }
      throw error
    } else {
      const poiPoaXmlData = atob(resp?.KuaRes?.kycRes?.[0]?._)
      console.log('poiPoaXmlData', poiPoaXmlData)
      const poiPoaJsonData: any = await parseXmlToJson(poiPoaXmlData, { explicitCharkey: true }).catch((err: any) => {
        console.log('err', err)
        const error = getNetworkResponseError(err)
        throw error
      })

      const { tkn, uid } = poiPoaJsonData?.KycRes?.UidData?.[0]?.$
      const { co, country, dist, house, pc, state, vtc, street, lm, loc, subdist, po } =
        poiPoaJsonData?.KycRes?.UidData?.[0]?.Poa?.[0]?.$

      console.log('Complete POA Attributes Object:', poiPoaJsonData?.KycRes?.UidData?.[0]?.Poa?.[0]?.$)
      const { dob, name, isResidentForeigner } = poiPoaJsonData?.KycRes?.UidData?.[0]?.Poi?.[0]?.$ || {}
      console.log('--- Checking isResidentForeigner Presence ---')
      console.log('isResidentForeigner value:', isResidentForeigner)
      console.log('Type of isResidentForeigner:', typeof isResidentForeigner)
      console.log(isResidentForeigner, "isResidentForeigner::")
      if (isResidentForeigner === 'Y' || isResidentForeigner === 'true') {
        console.log(isResidentForeigner, "insidethecurentcheckk::", poiPoaJsonData)
        const error = {
          code: 'FOREIGNER_RESIDENT_RESTRICTION',
          message: 'Services are not available for foreign residents.',
        }
        throw error
      }
      const encrypetedAdhaarXml = getEncryptedAadharXml(resp, poiPoaJsonData, uid)
      return {
        firstName: getFirstName(name) ?? ' ',
        lastName: getLastName(name) ?? ' ',
        dob,
        doorNumber: [co, house, lm, po].filter((item) => item?.length > 0).join(' ,'),
        street: [street, subdist, dist].filter((item) => item?.length > 0).join(' ,'),
        pinCode: pc,
        city: vtc,
        state: state,
        occupation: 'NA',
        aadhaarToken: resp?.KuaRes?.token?.[0]?._,
      }
    }
  } else {
    throw getNetworkResponseError(data?.data)
  }
}
export const fetchKycDetailsApi = (tokens: any, body: any, maskedAadhar: any) => {
  const config = sitConfig(tokens)
  config.headers['Content-Type'] = 'text/xml'
  const traceId = config.headers['x-trace-id']
  const request: Request<{}> = {
    apiPath: APIEndPoints.fetchKycDetails,
    method: 'POST',
    config: config,
    cache: false,
    responseType: 'text',
    body,
  }

  let saTxn = null
  try {
    const parser = new DOMParser()
    const domXml = parser.parseFromString(body, 'text/xml')
    saTxn = domXml?.getElementsByTagName('saTxn')?.[0]?.childNodes?.[0]?.nodeValue ?? null
  } catch (error) {
    console.log('xml parse error')
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((error) => {
      const data = getNetworkResponseError(error)
      const additionalDataAsJson = {
        status: 'FAILED',
        errorCode: data?.code,
        errorDescription: error,
        traceId: traceId,
        aadhar: maskedAadhar,
        saTxn: saTxn,
      }
      sendEventApi(tokens, request, additionalDataAsJson)
      throw error
    })
  // .catch((err) => responseParser(err))
}
